(function () {
  const Core = window.RB.Core;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Annie, Stubborn": {
      targets: [{ bind: "t", spec: { type: "spell", zone: "trash" }, prompt: "Return a spell from your trash to your hand" }],
      play: [{ op: "toHand", to: "$t" }],
    },

    "Flash": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, min: 0, max: 2, prompt: "Move up to 2 friendly units to base" }],
      play: [{ op: "move", to: "$t", dest: "base" }],
    },
  });
})();
